import { render, staticRenderFns } from "./UnorderedList.vue?vue&type=template&id=73afdc4a&scoped=true&lang=pug&"
import script from "./UnorderedList.vue?vue&type=script&lang=ts&"
export * from "./UnorderedList.vue?vue&type=script&lang=ts&"
import style0 from "./UnorderedList.vue?vue&type=style&index=0&id=73afdc4a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73afdc4a",
  null
  
)

export default component.exports